import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminLogin, adminLogout, adminMe } from "./api";

const AuthContext = createContext({
    isAdmin: false,
    loading: true,
    login: async () => {},
    logout: async () => {},
});

export function AuthProvider({ children }) {
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            await adminMe();
            setIsAdmin(true);
        } catch {
            setIsAdmin(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = useCallback(
        async (password) => {
            await adminLogin(password);
            await refresh();
        },
        [refresh],
    );

    const logout = useCallback(async () => {
        try {
            await adminLogout();
        } finally {
            setIsAdmin(false);
        }
    }, []);

    return (
        <AuthContext.Provider value={{ isAdmin, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
